<template>
    <div class="errors bg-light-red text-red border-radius-15 p-2 mb-2" v-if="errors.length">
        <ul class="mb-0">
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Errors",
    props: {
        errors: {
            type: Array,
            required: true
        }
    },
};
</script>
